import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const paymentMethodsImporterSelectors = importerSelectors(
  'paymentMethods.importer',
)

export default paymentMethodsImporterSelectors
